const REDUX_SLICE_NAMES = {
  USER_INFO: 'USER_INFO',
  AUTHENTICATION: 'AUTHENTICATION',
  LOADING: 'LOADING',
};

export default REDUX_SLICE_NAMES;
